<template>
  <v-card-text>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="provider"
          clearable
          label="Poskytovateľ"
          outlined
          filled
          dense
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="name"
          clearable
          label="Jméno"
          outlined
          filled
          dense
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="address"
          clearable
          label="Adresa"
          outlined
          filled
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <datetime-picker
          v-model="from"
          :text-field-props="{
            'hide-details': 'auto',
            filled: true,
            dense: true,
          }"
          outlined
          label="Od:"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <datetime-picker
          v-model="to"
          :text-field-props="{
            'hide-details': 'auto',
            filled: true,
            dense: true,
          }"
          outlined
          label="Do:"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-select
          v-model="selectedStatus"
          clearable
          chips
          label="Stav"
          :items="status"
          multiple
          filled
          dense
          outlined
          auto-grow
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-select
          v-model="selectedOrderType"
          clearable
          chips
          label="Typ objednávky"
          :items="orderTypes"
          multiple
          filled
          dense
          outlined
          auto-grow
        />
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn small color="primary" outlined @click="emitFilterObject">
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: "CleaningServicesFilter",
  props: {
    orders: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      status: [
        "active",
        "accepted",
        "in_progress",
        "completed",
        "finished",
        "canceled",
        "backup_payment_failed",
        "additional_payment_failed",
        "payment_failed",
      ],
      orderTypes: [
        "repeated_order_base",
        "repeated_order",
        "standard_order",
      ],
      name: "",
      provider: "",
      address: "",
      from: null,
      to: null,
      selectedStatus: [],
      selectedOrderType: [],
    };
  },
  methods: {
    emitFilterObject() {
      const filterParams = this.createFilterObject();
      this.$emit("filter", filterParams);
    },
    createFilterObject() {
      const filterParams = {
        filter: {},
      };

      if (this.name) {
        filterParams.filter.customer = this.name;
      }

      if (this.provider) {
        filterParams.filter.provider = this.provider;
      }

      if (this.address) {
        filterParams.filter.address = this.address;
      }

      if (this.from || this.to) {
        filterParams.filter.dateAndTime = {};
        if (this.from) {
          filterParams.filter.dateAndTime.from = new Date(this.from);
        }
        if (this.to) {
          filterParams.filter.dateAndTime.to = new Date(this.to);
        }
      }

      if (this.selectedStatus.length > 0) {
        filterParams.filter.status = this.selectedStatus;
      }

      if (this.selectedOrderType.length > 0) {
        filterParams.filter.orderType = this.selectedOrderType;
      }

      return filterParams;
    },
  },
};
</script>
